import {
  Box,
  TextField,
  InputLabel,
  Grid,
  Tooltip,
  IconButton,
} from "@mui/material/";
//import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import SearchIcon from "@mui/icons-material/Search";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import "./../genericModels.css";
import { useTranslation } from "react-i18next";
import GenericFilterBox from "../common/GenericFilterBox";

export const CarRangeFilterAndSearch = (props: any) => {
  let SearchCarRange = props.SearchCarRange;
  let dataFormSearchFieldCarRange = props.dataFormSearchFieldCarRange;
  let setDataFormSearchFieldCarRange = props.setDataFormSearchFieldCarRange;
  let resetFormTextCarRange = props.resetFormTextCarRange;

  const { t } = useTranslation(["operation"]);

  const handleChangeCarRange = (event: any, type: any) => {
    setDataFormSearchFieldCarRange({
      ...dataFormSearchFieldCarRange,
      [type]: event.target.value,
    });
  };

  const Search = (e: any) => {
    e.preventDefault();
    props.setResetFormValue(!props.resetFormValue);
  };

  return (
    <>
      <Box>
        <form id="idRangeForm" onSubmit={(e) => Search(e)}>
          <GenericFilterBox
            formId="idRangeForm"
            onReset={resetFormTextCarRange}
            showExtrasFilters={false}
          >
            
            <Box>
              <TextField
                fullWidth
                //placeholder={t("carRange.descriptionLabel")}
                label={t("carRange.descriptionRange")}
                variant="standard"
                id="descr"
                name="descr"
                value={dataFormSearchFieldCarRange.descr}
                onChange={(event: any) => handleChangeCarRange(event, "descr")}
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event: any) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>

            <Box>
              <TextField
                fullWidth
                //placeholder={t("carRange.codeLabel")}
                label={t("carRange.codeRange")}
                variant="standard"
                id="code"
                name="code"
                value={dataFormSearchFieldCarRange.code}
                onChange={(event: any) => handleChangeCarRange(event, "code")}
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event: any) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>
          </GenericFilterBox>
        </form>
      </Box>
    </>
  );
};
